import { Chip as MuiChip } from "@mui/material";
import React from "react";
import aderantTheme from "../Theme/AderantTheme";
/**
 * Custom DisplayChip control.
 * @param props @see DisplayChipProps
 *
 */
const palette = aderantTheme.palette;
export function DisplayChip({ text, className, chipColor, chipBorderColor, textColor }) {
    const MuiChipStyleOverrides = ({ palette }) => ({
        "&.MuiChip-root": {
            boxShadow: "1px 1px 2px 0 rgba(0, 0, 0, 0.1)",
            height: "29px",
            "&.MuiChip-outlined": {
                border: `1px solid ${chipBorderColor}`,
                borderRadius: "6px",
                backgroundColor: chipColor,
                color: textColor
            }
        }
    });
    return React.createElement(MuiChip, { color: "primary", label: text, variant: "outlined", sx: MuiChipStyleOverrides, className: className });
}
//Prop defaults
DisplayChip.defaultProps = {
    chipColor: palette.background.default,
    chipBorderColor: palette.border.main,
    textColor: palette.text.primary
};
